import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import PDPStickyButtonsContext from './PDPStickyButtonsContext';
const PDPStickyButtonsProvider = t0 => {
  const $ = _c(9);
  const {
    children
  } = t0;
  const [showStickyButtons, setShowStickyButtons] = useState(false);
  const [stickyPriceRowsById, setStickyPriceRowsById] = useState(_temp);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (id, node) => {
      setStickyPriceRowsById(previous => {
        if (!node && !previous.has(id)) {
          return previous;
        }
        const next = new Map(previous);
        if (node) {
          next.set(id, node);
        } else {
          next.delete(id);
        }
        return next;
      });
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const registerStickyPriceRow = t1;
  let t2;
  if ($[1] !== stickyPriceRowsById) {
    t2 = stickyPriceRowsById.values().next().value ?? null;
    $[1] = stickyPriceRowsById;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const stickyPriceRow = t2;
  let t3;
  if ($[3] !== showStickyButtons || $[4] !== stickyPriceRow) {
    t3 = {
      showStickyButtons,
      setShowStickyButtons,
      stickyPriceRow,
      registerStickyPriceRow
    };
    $[3] = showStickyButtons;
    $[4] = stickyPriceRow;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const value = t3;
  let t4;
  if ($[6] !== children || $[7] !== value) {
    t4 = <PDPStickyButtonsContext.Provider value={value}>{children}</PDPStickyButtonsContext.Provider>;
    $[6] = children;
    $[7] = value;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
PDPStickyButtonsProvider.propTypes = {
  children: PropTypes.node
};
export default PDPStickyButtonsProvider;
function _temp() {
  return new Map();
}